import { createPortal } from 'react-dom'

import { Modal } from 'react-bootstrap'
import Select from 'react-select'
import { KTSVG } from '_metronic/helpers'

import useViewModel from './ViewModel'

const UserFormModalView: React.FC = () => {
  const {
    modalsRoot,
    formType,
    isOpenUserModal,
    isLoadingRoles,
    roleOptions,
    handleClose,
    formik,
  } = useViewModel()

  return createPortal(
    <Modal
      id='kt_modal_user_form'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={isOpenUserModal}
      onHide={handleClose}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2 className='mb-0'>{formType === 'add' ? 'เพิ่มผู้ใช้งาน' : 'แก้ไขผู้ใช้งาน'}</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <form
          onSubmit={(e: any) => {
            e.preventDefault()
            formik.handleSubmit()
          }}>
          <div className='modal-body py-lg-10 px-lg-10 min-h-200px'>
            <div className='row gy-3'>
              {/* begin:: Name */}
              <div className='col-12'>
                <label htmlFor='username' className='fs-6 mb-3'>
                  ชื่อผู้ใช้งาน
                  <span className='required' />
                </label>

                <input
                  type='text'
                  disabled={formType === 'edit'}
                  className='form-control form-control-sm'
                  {...formik.getFieldProps('username')}
                />

                {formik.touched.username && formik.errors.username && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.username}</div>
                  </div>
                )}
              </div>
              {/* end:: Name */}

              {/* begin:: Name */}
              <div className='col-12'>
                <label htmlFor='fullName' className='fs-6 mb-3'>
                  ชื่อ-นามสกุล
                  <span className='required' />
                </label>

                <input
                  type='text'
                  className='form-control form-control-sm'
                  {...formik.getFieldProps('fullName')}
                />

                {formik.touched.fullName && formik.errors.fullName && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.fullName}</div>
                  </div>
                )}
              </div>
              {/* end:: Name */}

              {/* begin:: Email */}
              <div className='col-12'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  ตำแหน่ง
                  <span className='required' />
                </label>

                <Select
                  isSearchable
                  isClearable={false}
                  isLoading={isLoadingRoles}
                  options={roleOptions}
                  placeholder='เลือกตำแหน่ง'
                  value={roleOptions.find(o => o.value === formik.values.roleId) ?? null}
                  onChange={(e: any) => formik.setFieldValue('roleId', e?.value)}
                  onBlur={() => formik.setFieldTouched('roleId', true)}
                />

                {/* <input
                  type='text'
                  className='form-control form-control-sm'
                  {...formik.getFieldProps('roleId')}
                /> */}

                {formik.touched.roleId && formik.errors.roleId && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.roleId}</div>
                  </div>
                )}
              </div>
              {/* end:: Email */}

              {/* begin:: Password */}
              <div className='col-12'>
                <label htmlFor='password' className='fs-6 mb-3'>
                  รหัสผ่าน
                  <span className='required' />
                </label>

                <input
                  type='text'
                  className='form-control form-control-sm'
                  {...formik.getFieldProps('password')}
                />

                {formik.touched.password && formik.errors.password && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.password}</div>
                  </div>
                )}
              </div>
              {/* end:: Password */}
            </div>
          </div>

          <div className='modal-footer'>
            <div
              className='col-12 d-flex flex-row justify-content-end'
              style={{ columnGap: '12px' }}>
              <button
                type='reset'
                className='btn btn-sm btn-light fw-bolder'
                onClick={handleClose}
                disabled={formik.isSubmitting}>
                ยกเลิก
              </button>
              <button
                type='submit'
                className='btn btn-sm btn-success me-4 fw-bold'
                disabled={formik.isSubmitting || !formik.isValid}>
                บันทึก
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default UserFormModalView
